"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Stargate Internal
 * Invitae API for internal apps
 *
 * The version of the OpenAPI document: 11.17.2
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrderConfigsApi = void 0;
var runtime = require("../runtime");
var models_1 = require("../models");
/**
 *
 */
var OrderConfigsApi = /** @class */ (function (_super) {
    __extends(OrderConfigsApi, _super);
    function OrderConfigsApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Return audit logs for an order config.
     */
    OrderConfigsApi.prototype.getAuditLogsFromOrderConfigControllerRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.orderConfigId === null || requestParameters.orderConfigId === undefined) {
                            throw new runtime.RequiredError('orderConfigId', 'Required parameter requestParameters.orderConfigId was null or undefined when calling getAuditLogsFromOrderConfigController.');
                        }
                        queryParameters = {};
                        if (requestParameters.pageNumber !== undefined) {
                            queryParameters['pageNumber'] = requestParameters.pageNumber;
                        }
                        if (requestParameters.pageSize !== undefined) {
                            queryParameters['pageSize'] = requestParameters.pageSize;
                        }
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/order-configs/{orderConfigId}/audit-logs".replace("{".concat("orderConfigId", "}"), encodeURIComponent(String(requestParameters.orderConfigId))),
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, models_1.PaginatedOrderConfigAuditLogFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Return audit logs for an order config.
     */
    OrderConfigsApi.prototype.getAuditLogsFromOrderConfigController = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getAuditLogsFromOrderConfigControllerRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * return order configuration
     */
    OrderConfigsApi.prototype.getConfigFromOrderConfigControllerRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.groupId === null || requestParameters.groupId === undefined) {
                            throw new runtime.RequiredError('groupId', 'Required parameter requestParameters.groupId was null or undefined when calling getConfigFromOrderConfigController.');
                        }
                        queryParameters = {};
                        if (requestParameters.groupId !== undefined) {
                            queryParameters['groupId'] = requestParameters.groupId;
                        }
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/order-configs/getConfig",
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return jsonValue.map(models_1.OrderConfigResDtoFromJSON); })];
                }
            });
        });
    };
    /**
     * return order configuration
     */
    OrderConfigsApi.prototype.getConfigFromOrderConfigController = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getConfigFromOrderConfigControllerRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * return expanded test selection
     */
    OrderConfigsApi.prototype.getExpandedTestSelectionFromOrderConfigControllerRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.testSelectionResDto === null || requestParameters.testSelectionResDto === undefined) {
                            throw new runtime.RequiredError('testSelectionResDto', 'Required parameter requestParameters.testSelectionResDto was null or undefined when calling getExpandedTestSelectionFromOrderConfigController.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/order-configs/get-expanded-test-selection",
                            method: 'POST',
                            headers: headerParameters,
                            query: queryParameters,
                            body: requestParameters.testSelectionResDto.map(models_1.TestSelectionResDtoToJSON),
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, models_1.ExpandedTestSelectionResDtoFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * return expanded test selection
     */
    OrderConfigsApi.prototype.getExpandedTestSelectionFromOrderConfigController = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getExpandedTestSelectionFromOrderConfigControllerRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Get Practice by Practice Id
     */
    OrderConfigsApi.prototype.getPracticeFromOrderConfigControllerRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.practiceId === null || requestParameters.practiceId === undefined) {
                            throw new runtime.RequiredError('practiceId', 'Required parameter requestParameters.practiceId was null or undefined when calling getPracticeFromOrderConfigController.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/order-configs/practices/{practiceId}".replace("{".concat("practiceId", "}"), encodeURIComponent(String(requestParameters.practiceId))),
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, models_1.BopPracticeDtoFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Get Practice by Practice Id
     */
    OrderConfigsApi.prototype.getPracticeFromOrderConfigController = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getPracticeFromOrderConfigControllerRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * return order configuration verification type
     */
    OrderConfigsApi.prototype.getVerificationTypeFromOrderConfigControllerRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.groupId === null || requestParameters.groupId === undefined) {
                            throw new runtime.RequiredError('groupId', 'Required parameter requestParameters.groupId was null or undefined when calling getVerificationTypeFromOrderConfigController.');
                        }
                        queryParameters = {};
                        if (requestParameters.groupId !== undefined) {
                            queryParameters['groupId'] = requestParameters.groupId;
                        }
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/order-configs/getVerificationType",
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.TextApiResponse(response)];
                }
            });
        });
    };
    /**
     * return order configuration verification type
     */
    OrderConfigsApi.prototype.getVerificationTypeFromOrderConfigController = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getVerificationTypeFromOrderConfigControllerRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * return matched order configurations
     */
    OrderConfigsApi.prototype.groupSearchFromOrderConfigControllerRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.search === null || requestParameters.search === undefined) {
                            throw new runtime.RequiredError('search', 'Required parameter requestParameters.search was null or undefined when calling groupSearchFromOrderConfigController.');
                        }
                        if (requestParameters.pageNumber === null || requestParameters.pageNumber === undefined) {
                            throw new runtime.RequiredError('pageNumber', 'Required parameter requestParameters.pageNumber was null or undefined when calling groupSearchFromOrderConfigController.');
                        }
                        if (requestParameters.pageSize === null || requestParameters.pageSize === undefined) {
                            throw new runtime.RequiredError('pageSize', 'Required parameter requestParameters.pageSize was null or undefined when calling groupSearchFromOrderConfigController.');
                        }
                        if (requestParameters.exactMatchFirst === null || requestParameters.exactMatchFirst === undefined) {
                            throw new runtime.RequiredError('exactMatchFirst', 'Required parameter requestParameters.exactMatchFirst was null or undefined when calling groupSearchFromOrderConfigController.');
                        }
                        queryParameters = {};
                        if (requestParameters.search !== undefined) {
                            queryParameters['search'] = requestParameters.search;
                        }
                        if (requestParameters.pageNumber !== undefined) {
                            queryParameters['pageNumber'] = requestParameters.pageNumber;
                        }
                        if (requestParameters.pageSize !== undefined) {
                            queryParameters['pageSize'] = requestParameters.pageSize;
                        }
                        if (requestParameters.exactMatchFirst !== undefined) {
                            queryParameters['exactMatchFirst'] = requestParameters.exactMatchFirst;
                        }
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/order-configs/groupSearch",
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, models_1.GroupSearchResDtoFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * return matched order configurations
     */
    OrderConfigsApi.prototype.groupSearchFromOrderConfigController = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.groupSearchFromOrderConfigControllerRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Lookup commercial tests
     */
    OrderConfigsApi.prototype.lookupCommercialTestsFromOrderConfigControllerRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.commercialTestsRequestBodyDto === null || requestParameters.commercialTestsRequestBodyDto === undefined) {
                            throw new runtime.RequiredError('commercialTestsRequestBodyDto', 'Required parameter requestParameters.commercialTestsRequestBodyDto was null or undefined when calling lookupCommercialTestsFromOrderConfigController.');
                        }
                        queryParameters = {};
                        if (requestParameters.fields !== undefined) {
                            queryParameters['fields'] = requestParameters.fields;
                        }
                        if (requestParameters.sort !== undefined) {
                            queryParameters['sort'] = requestParameters.sort;
                        }
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/order-configs/commercial-tests",
                            method: 'POST',
                            headers: headerParameters,
                            query: queryParameters,
                            body: (0, models_1.CommercialTestsRequestBodyDtoToJSON)(requestParameters.commercialTestsRequestBodyDto),
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return jsonValue.map(models_1.CommercialTestDtoFromJSON); })];
                }
            });
        });
    };
    /**
     * Lookup commercial tests
     */
    OrderConfigsApi.prototype.lookupCommercialTestsFromOrderConfigController = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.lookupCommercialTestsFromOrderConfigControllerRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * return matched patient access
     */
    OrderConfigsApi.prototype.patientAccessSearchFromOrderConfigControllerRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.orderConfigId === null || requestParameters.orderConfigId === undefined) {
                            throw new runtime.RequiredError('orderConfigId', 'Required parameter requestParameters.orderConfigId was null or undefined when calling patientAccessSearchFromOrderConfigController.');
                        }
                        queryParameters = {};
                        if (requestParameters.orderConfigId !== undefined) {
                            queryParameters['orderConfigId'] = requestParameters.orderConfigId;
                        }
                        if (requestParameters.pageSize !== undefined) {
                            queryParameters['pageSize'] = requestParameters.pageSize;
                        }
                        if (requestParameters.search !== undefined) {
                            queryParameters['search'] = requestParameters.search;
                        }
                        if (requestParameters.pageNumber !== undefined) {
                            queryParameters['pageNumber'] = requestParameters.pageNumber;
                        }
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/order-configs/patient-access-search",
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, models_1.PatientAccessSearchDtoFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * return matched patient access
     */
    OrderConfigsApi.prototype.patientAccessSearchFromOrderConfigController = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.patientAccessSearchFromOrderConfigControllerRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * return new or updated order config
     */
    OrderConfigsApi.prototype.saveConfigFromOrderConfigControllerRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.createOrUpdateOrderConfigDto === null || requestParameters.createOrUpdateOrderConfigDto === undefined) {
                            throw new runtime.RequiredError('createOrUpdateOrderConfigDto', 'Required parameter requestParameters.createOrUpdateOrderConfigDto was null or undefined when calling saveConfigFromOrderConfigController.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/order-configs/save-config",
                            method: 'POST',
                            headers: headerParameters,
                            query: queryParameters,
                            body: (0, models_1.CreateOrUpdateOrderConfigDtoToJSON)(requestParameters.createOrUpdateOrderConfigDto),
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, models_1.OrderConfigUpdateDtoFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * return new or updated order config
     */
    OrderConfigsApi.prototype.saveConfigFromOrderConfigController = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.saveConfigFromOrderConfigControllerRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * return updated patient access
     */
    OrderConfigsApi.prototype.savePatientAccessFromOrderConfigControllerRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.patientAccessUpdateDto === null || requestParameters.patientAccessUpdateDto === undefined) {
                            throw new runtime.RequiredError('patientAccessUpdateDto', 'Required parameter requestParameters.patientAccessUpdateDto was null or undefined when calling savePatientAccessFromOrderConfigController.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/order-configs/patient-access-update",
                            method: 'POST',
                            headers: headerParameters,
                            query: queryParameters,
                            body: (0, models_1.PatientAccessUpdateDtoToJSON)(requestParameters.patientAccessUpdateDto),
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, models_1.PatientAccessResponseDtoFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * return updated patient access
     */
    OrderConfigsApi.prototype.savePatientAccessFromOrderConfigController = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.savePatientAccessFromOrderConfigControllerRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Validate user by patientProperties
     */
    OrderConfigsApi.prototype.validatePatientFromOrderConfigControllerRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.patientValidateRequestDto === null || requestParameters.patientValidateRequestDto === undefined) {
                            throw new runtime.RequiredError('patientValidateRequestDto', 'Required parameter requestParameters.patientValidateRequestDto was null or undefined when calling validatePatientFromOrderConfigController.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/order-configs/validate-patient",
                            method: 'POST',
                            headers: headerParameters,
                            query: queryParameters,
                            body: (0, models_1.PatientValidateRequestDtoToJSON)(requestParameters.patientValidateRequestDto),
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, models_1.ValidatePatientResponseDtoFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Validate user by patientProperties
     */
    OrderConfigsApi.prototype.validatePatientFromOrderConfigController = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.validatePatientFromOrderConfigControllerRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    return OrderConfigsApi;
}(runtime.BaseAPI));
exports.OrderConfigsApi = OrderConfigsApi;
